<div class="time-selector-header">
    <div class="time-selector-header-time">
        <div class="time-selector-header-time-hour"
             [class.selected]="hourDial" (click)="hourDial = true">{{hour12(hour) | number:'1.0-0'}}</div>
        <div class="time-selector-header-time-separator">:</div>
        <div class="time-selector-header-time-minute"
             [class.selected]="!hourDial" (click)="hourDial = false">{{minute | number: '2.0-0'}}</div>
        <div class="time-selector-header-time-ampm">
            <div class="time-selector-header-time-ampm-am"
                 [class.selected]="!pm" (click)="pm = false">AM</div>
            <div class="time-selector-header-time-ampm-pm"
                 [class.selected]="pm" (click)="pm = true">PM</div>
        </div>
    </div>
</div>
<div class="time-selector-body">
    <div class="time-selector-body-dial"
         (mousedown)="mouseDown($event)" (mouseup)="mouseUp()" (mousemove)="mouseMove($event)"
         (touchstart)="touch($event)" (touchmove)="touch($event)">
        <div *ngFor="let i of [].constructor(12); let position = index"
             class="time-selector-body-dial-number"
             [class.selected]="hourDial ? (position === hour % 12) : (position * 5 === minute)"
             [style.--p]="position">{{dialNumber(position) | number:(hourDial ? '1.0-0' : '2.0-0')}}</div>
        <div *ngIf="!hourDial && minute % 5 != 0" class="time-selector-body-dial-minute"
             [style.--m]="minute"></div>
        <div class="time-selector-body-dial-pivot"></div>
        <div class="time-selector-body-dial-hand"
             [style.--m]="hourDial ? (hour % 12 * 5) : minute"></div>
    </div>
</div>
<div class="time-selector-footer">
    <fui-icon class="time-selector-footer-accept" [width]="21" [height]="21" [icon]="'success'"
              [clickable]="true" (click)="accept()"></fui-icon>
</div>
